import { Link } from "react-router-dom";
import { ArrowRight, Check, Users, Clock } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { IMAGES } from "../lib/images";
import { Reveal } from "../components/Reveal";
import { SEO } from "../components/SEO";

export default function FloatingPicnic() {
  const { t } = useLanguage();
  return (
    <div data-testid="floating-page">
      <SEO title="Floating Picnic Nice — Villefranche-sur-Mer | The Nice Picnic"
        description="Floating Picnic: a private picnic on the water at Port de la Darse, Villefranche-sur-Mer. Swimming, snorkelling, wine and Niçoise specialties. €89 per person, 2 guests max." />

      <section className="relative min-h-[70svh] flex items-end pt-20">
        <div className="absolute inset-0">
          <img src={IMAGES.floatingHero} alt="Floating Picnic — guests relaxing on the floating lounge in the bay of Villefranche-sur-Mer" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#181513]/75 via-[#181513]/20 to-transparent" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 pb-16 sm:pb-24 w-full">
          <Reveal>
            <p className="overline-label !text-gold">{t("floating.overline")}</p>
            <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-ivory mt-4">Floating Picnic</h1>
          </Reveal>
        </div>
      </section>

      <section className="py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 md:grid-cols-12 gap-10">
          <Reveal className="md:col-span-7">
            <p className="text-lg sm:text-xl text-earth font-light leading-relaxed">{t("floating.intro")}</p>
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div className="border border-champagne rounded-2xl p-6 flex items-start gap-4">
                <Users size={20} className="text-terracotta mt-1 shrink-0" />
                <p className="text-sm text-earth leading-relaxed">{t("floating.priceNote")} {t("floating.exclusiveNote")}</p>
              </div>
              <div className="border border-champagne rounded-2xl p-6 flex items-start gap-4">
                <Clock size={20} className="text-terracotta mt-1 shrink-0" />
                <div>
                  <p className="text-sm font-medium text-ink">{t("floating.slotsTitle")}</p>
                  <p className="text-sm text-earth mt-1">17:00 – 18:30 · 18:30 – 20:00</p>
                </div>
              </div>
            </div>
            <Link to="/booking?experience=floating" data-testid="floating-book-btn" className="btn-primary mt-10">
              {t("floating.bookCta")} <ArrowRight size={16} />
            </Link>
          </Reveal>
          <Reveal delay={0.1} className="md:col-span-5">
            <div className="img-frame organic-crop-alt">
              <img src={IMAGES.floatingCove} alt="Guests gathered on cushions at dusk above the Mediterranean" className="w-full h-80 object-cover" loading="lazy" />
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-20 sm:py-28 bg-cream" data-testid="floating-includes">
        <div className="max-w-5xl mx-auto px-5 sm:px-8">
          <Reveal className="text-center">
            <p className="overline-label">{t("floating.includesTitle")}</p>
            <div className="w-16 h-px bg-gold mt-6 mx-auto" />
          </Reveal>
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-4 max-w-4xl mx-auto">
            {t("floating.includes").map((item) => (
              <Reveal key={item} className="flex items-start gap-3 text-sm text-earth">
                <Check size={15} className="text-olive mt-0.5 shrink-0" /> {item}
              </Reveal>
            ))}
          </div>
          <Reveal className="text-center mt-14">
            <p className="font-serif text-4xl text-clay">89 € <span className="text-lg text-earth">{t("common.perPerson")}</span></p>
            <Link to="/booking?experience=floating" data-testid="floating-book-btn-2" className="btn-primary mt-8">
              {t("floating.bookCta")} <ArrowRight size={16} />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
